<script>
import baseList from "@/views/components/base/baseList.vue";
import config from "@/../config";
import { Button } from "view-design";
import Checkout from "./checkout.vue";

export default {
  extends: baseList,
  components: {
    Checkout,
  },
  data() {
    return {
      table: {
        mname: "sysTask_my",
        key: "id",
        url: {
          list: `/maintainer/maintainer/task/mylist`,
          del: `/maintainer/maintainer/task/del`,
        },
        output: false,
      },
      menus: [],
      actions: [
        // {
        //   label: "新增任务",
        //   icon: "md-add",
        //   onClick: this.toAdd,
        //   auth: "",
        //   type: "info",
        // },
      ],
      filters: [
        {
          label: "申请人",
          name: "applyUser",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "申请内容",
          name: "applyContent",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "处理内容",
          name: "finishContent",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },

        {
          label: "紧急程度",
          name: "emergencyDegree",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "一般",
            },
            {
              value: 2,
              name: "较重",
            },
            {
              value: 3,
              name: "重要",
            },
            {
              value: 4,
              name: "特别重要",
            },
          ],
        },
        {
          label: "状态",
          name: "state",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "未完成",
            },
            {
              value: 2,
              name: "已完成",
            },
          ],
        },
      ],
      tableCols: [
        // {
        //   type: "selection",
        //   width: 60,
        // },
        {
          title: "任务单号",
          key: "taskNo",
          minWidth: 120,
          align: "center",
          tooltip: "true",
        },
        {
          title: "申请人",
          key: "applyUser",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "申请内容",
          key: "applyContent",
          minWidth: 300,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.applyContent;
            let tempDescr;
            let teColor;
            if (text != null) {
              let arr = text.split("]");
              let tempDate = parseInt(arr[0]);
              let tempContext = text.replace(arr[0] + "]", "");
              if (row.state == 1) {
                tempDescr = "[" + "0h" + tempDate + "m]" + tempContext;
                teColor = "red";
              } else if (row.state == 2) {
                let hour = Math.floor(tempDate / 60);
                let min = tempDate % 60;
                tempDescr = "[" + hour + "h" + min + "m]" + tempContext;
              }
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: teColor,
                  },
                  domProps: {
                    title: tempDescr,
                  },
                },
                tempDescr
              ),
            ]);
          },
        },
        {
          title: "申请科室",
          key: "applyDeskName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },

        {
          title: "申请时间",
          width: 150,
          align: "center",
          key: "applyTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.applyTime.slice(0, 16);
            return <span> {text} </span>;
          },
        },
        {
          title: "紧急程度",
          key: "emergencyDegree",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.emergencyDegree;
            if (text == 1) {
              return <span>一般</span>;
            } else if (text == 2) {
              return <span>较重要</span>;
            } else if (text == 3) {
              return <span>重要</span>;
            } else if (text == 4) {
              return <span>特别重要</span>;
            }
          },
        },
        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state;
            if (text == 1) {
              return <span>未完成</span>;
            } else if (text == 2) {
              return <span>已完成</span>;
            }
          },
        },
        {
          title: "申请文件",
          key: "applyFileUrl",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            if (row.applyFileUrl !== null) {
              const text = config.IMAGE_HOST + row.applyFileUrl;
              return (
                <a style="margin-left:20px" href={text} target="_blank">
                  <svg
                    t="1686795127586"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="7800"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                      fill="#CCA352"
                      p-id="7801"
                    ></path>
                    <path
                      d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                      fill="#FFFFFF"
                      p-id="7802"
                    ></path>
                    <path
                      d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                      fill="#FFCC66"
                      p-id="7803"
                    ></path>
                  </svg>
                </a>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "处理内容",
          key: "finishContent",
          minWidth: 130,
          align: "left",
        },
        {
          title: "完成时间",
          width: 150,
          align: "center",
          key: "finishTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.finishTime != null ? row.finishTime.slice(0, 16) : "";
            return <span> {text} </span>;
          },
        },
        {
          title: "结果文件",
          key: "resultFileUrl",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            if (row.resultFileUrl != null) {
              const text = config.IMAGE_HOST + row.resultFileUrl;
              return (
                <a style="margin-left:10px" href={text} target="_blank">
                  <svg
                    t="1686795127586"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="7800"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                      fill="#CCA352"
                      p-id="7801"
                    ></path>
                    <path
                      d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                      fill="#FFFFFF"
                      p-id="7802"
                    ></path>
                    <path
                      d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                      fill="#FFCC66"
                      p-id="7803"
                    ></path>
                  </svg>
                </a>
              );
            } else {
              return;
            }
          },
        },

        {
          title: "操作",
          align: "center",
          width: 130,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              const row = param.row;

              return (
                <Button
                  size="small"
                  onClick={() => this.tocheckout2(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    display: row.state === 1 ? "none" : "",
                  }}
                >
                  查看
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              const row = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => this.tocheckout(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                    display: row.state === 2 ? "none" : "",
                  }}
                >
                  填写处理记录
                </Button>
              );
            },
            // , "delete"
          ],
          auth: {
            edit: "/maintainer/maintainer/sysTask/edit",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({ name: "Edit_Task", query: { action: "add" } });
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "Edit_Task",
        query: { action: "edit", kv: kv },
      });
    },
    tocheckout(row) {
      this.facilityId = row.id;
      this.$Modal.success({
        closable: true,
        title: "填写处理记录",
        width: "80%",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Checkout style={{ margin: "0", color: "#19be6b" }} rows={row}></Checkout>
          );
        },
      });
    },
    tocheckout2(row) {
      this.facilityId = row.id;
      this.$Modal.success({
        closable: true,
        title: "查看任务信息",
        width: "80%",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Checkout style={{ margin: "0", color: "#19be6b" }} rows={row}></Checkout>
          );
        },
      });
    },
  },
};
</script>
<style scoped></style>
